import { render, staticRenderFns } from "./PravicePredelava.vue?vue&type=template&id=10a2e85e&"
import script from "./PravicePredelava.vue?vue&type=script&lang=js&"
export * from "./PravicePredelava.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports